/**
 * On an investigation: the hypothesis it is evidence for (ADR-0095), as a chip that opens the
 * hypothesis — "supports H1" in the analysis's words.
 */
import { Lightbulb } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Badge } from '@/components/ui/badge'

export interface HypothesisLinkChipProps {
  title: string
  /** The hypothesis page. */
  to: string
}

export function HypothesisLinkChip({ title, to }: HypothesisLinkChipProps) {
  const { t } = useTranslation()
  return (
    <Badge variant="default" className="h-6 max-w-full" asChild>
      <Link to={to} aria-label={t('analyticHypotheses.card.open', { title })}>
        <Lightbulb aria-hidden />
        <span className="truncate">{t('analyticHypotheses.link.supports', { title })}</span>
      </Link>
    </Badge>
  )
}
